import React, { Component } from "react";
import { connect } from "react-redux";
import NavbarClass from "../NavbarClass";
import { localAPI } from "../../api/local";
import { Redirect } from "react-router-dom";
import history from "../../config/history";
import ReactQuill, { Quill } from "react-quill";
import * as quillUtils from "../../utils/quillUtills";
import "./AdminPage.css";
import { Form, Button, Alert } from "react-bootstrap";
import { Form as ReactFinalForm, Field } from "react-final-form";
import {
  fetchBlogsAdmin,
  editBlog,
  deleteBlog,
  createBlog,
} from "../../actions/blogActions";
import { Helmet } from "react-helmet";

// import { ImageResize } from "quill-image-resize-module";
// Quill.register("modules/imageResize", ImageResize);

function imageHandler() {
  const tooltip = this.quill.theme.tooltip;
  const originalSave = tooltip.save;
  const originalHide = tooltip.hide;

  tooltip.save = function () {
    const range = this.quill.getSelection(true);
    const value = this.textbox.value;
    if (value) {
      this.quill.insertEmbed(range.index, "image", value, "user");
    }
  };
  // Called on hide and save.
  tooltip.hide = function () {
    tooltip.save = originalSave;
    tooltip.hide = originalHide;
    tooltip.hide();
  };
  tooltip.edit("image");
  tooltip.textbox.placeholder = "Embed URL";
}
const Size = Quill.import("formats/size");
Size.whitelist = [
  "extra-small",
  "small",
  "medium",
  "large",
  "12px",
  "14px",
  "16px",
  "18px",
];
Quill.register(Size, true);
// Add fonts to whitelist and register them
const Font = Quill.import("formats/font");

Font.whitelist = [
  "arial",
  "comic-sans",
  "courier-new",
  "georgia",
  "helvetica",
  "lucida",
];
Quill.register(Font, true);
// Quill.register("modules/imageResize", ImageResize);

// function imageHandler() {
//   var range = this.quill.getSelection();
//   var value = prompt("please copy paste the image url here.");
//   if (value) {
//     this.quill.insertEmbed(range.index, "image", value, Quill.sources.USER);
//   }
// }
class AdminBlogEntry extends Component {
  async componentDidMount() {
    await localAPI
      .get("/api/users/isadmin")
      .then((data) => {
        if (!data.data.success) this.setState({ isAdmin: false });
      })
      .catch((err) => {
        this.setState({ isAdmin: false });
      });

    if (this.props.blogToEdit && this.props.blogToEdit != {}) {
      this.state.quillValue = this.props.blogToEdit.content;
      this.state.quillValueHtml = this.props.blogToEdit.contentHtml;
    }
  }

  state = {
    isAdmin: true,
    quillValue: {},
    quillValueHtml: "",
    storyData: {
      isFreeBlog: false,
      hideBlog: false,
    },
  };

  onSubmit = async (values) => {
    if (!this.props.blogToEdit || this.props.blogToEdit == {}) {
      await this.props.createBlog({
        ...values,
        content: this.state.quillValue,
        contentHTML: this.state.quillValueHtml,
      });
    } else {
      await this.props.editBlog({
        ...values,
        content: this.state.quillValue
          ? this.state.quillValue
          : this.props.blogToEdit.content,
        contentHTML: this.state.quillValueHtml
          ? this.state.quillValueHtml
          : this.props.blogToEdit.contentHtml,
        _id: this.props.blogToEdit._id,
      });
    }
  };

  onQuillChange = (content, delta, source, editor) => {
    this.setState({
      quillValue: editor.getContents(),
      quillValueHtml: content,
    });
  };

  render() {
    return (
      <div className="container">
        <Helmet>
          <meta name="robots" content="noindex" />
        </Helmet>
        {/* {!this.state.isAdmin && <Redirect to="/" />} */}
        {this.state.isAdmin ? (
          <div>
            <ReactFinalForm
              initialValues={this.props.blogToEdit ? this.props.blogToEdit : {}}
              onSubmit={this.onSubmit}
              render={({
                handleSubmit,
                form,
                submitting,
                pristine,
                values,
              }) => {
                return (
                  <form onSubmit={handleSubmit}>
                    {this.props.error && (
                      <Alert variant="danger">
                        <p>{this.props.error}</p>
                      </Alert>
                    )}
                    <Field name="title">
                      {({ input, meta }) => (
                        <div>
                          <Form.Group className="mb-3">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                              {...input}
                              type="text"
                              placeholder="Enter title"
                              name="title"
                              // value={this.state.storyData.title}
                              autofocus
                            />
                          </Form.Group>
                        </div>
                      )}
                    </Field>
                    <Field name="thumbnailLink">
                      {({ input, meta }) => (
                        <div>
                          <Form.Group className="mb-3">
                            <Form.Label>Thumbnail Link</Form.Label>
                            <Form.Control
                              {...input}
                              type="text"
                              placeholder="Thumbnail Link"
                              // value={this.state.storyData.thumbnailLink}
                              name="thumbnailLink"
                            />
                          </Form.Group>
                        </div>
                      )}
                    </Field>
                    <Field name="category">
                      {({ input, meta }) => (
                        <div>
                          <Form.Group className="mb-3">
                            <Form.Label>Category</Form.Label>
                            <Form.Control
                              {...input}
                              type="text"
                              placeholder="Category"
                              name="category"
                              autofocus
                            />
                          </Form.Group>
                        </div>
                      )}
                    </Field>
                    <Field name="isFreeBlog" type="checkbox">
                      {({ input, meta }) => (
                        <div>
                          <label for="isFreeBlog">Free Blog</label>
                          <input
                            {...input}
                            type="checkbox"
                            id="isFreeBlog"
                            name="isFreeBlog"
                          />
                        </div>
                      )}
                    </Field>
                    <Field name="hideBlog" type="checkbox">
                      {({ input, meta }) => (
                        <div>
                          <label for="hideBlog">Hide Blog</label>
                          <input
                            {...input}
                            type="checkbox"
                            id="hideBlog"
                            name="hideBlog"
                          />
                        </div>
                      )}
                    </Field>
                    <Field name="storyContent" type="textarea">
                      {({ input, meta }) => (
                        <Form.Group>
                          <Form.Label>Content: </Form.Label>
                          <ReactQuill
                            key={1}
                            defaultValue={this.props.blogToEdit?.content}
                            modules={{
                              toolbar: {
                                container: quillUtils.toolbarOptions,
                                handlers: {
                                  image: imageHandler,
                                },
                              },
                              // imageResize: {},

                              // imageResize: {},
                            }}
                            formats={quillUtils.formats}
                            theme="snow"
                            // value={this.state.quillValue}
                            onChange={this.onQuillChange}
                          />
                        </Form.Group>
                      )}
                    </Field>

                    <button
                      className="btn btn-warning"
                      style={{ marginTop: "15px" }}
                      type="submit"
                    >
                      submit
                    </button>
                  </form>
                );
              }}
            />

            <Form.Group>
              <Form.Label>Test Display: </Form.Label>
              <ReactQuill
                key={2}
                readOnly
                value={this.state.quillValue}
                modules={{ toolbar: null }}
              />
            </Form.Group>

            <div>
              <strong>DELTA: </strong>
              {JSON.stringify(this.state.quillValue)}
            </div>
            <br />
            <br />
            <br />
            <br />
            <div>
              <strong>HTML: </strong>
              {this.state.quillValueHtml}
            </div>
          </div>
        ) : (
          <Redirect to="/" />
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // blogs: state.blogs.blogs?.blogs,
    // loading: state.blogs.loading,
    error: state?.blogs?.error,
    // type: state.type,
  };
};

export default connect(mapStateToProps, {
  fetchBlogsAdmin,
  editBlog,
  deleteBlog,
  createBlog,
})(AdminBlogEntry);
